import { VueExtension } from '../../utils/extensions/vue';
import Icon from './icon.jsx';
import './icon.scss';

VueExtension.WithInstall(Icon);

export default Icon;
